import {
  Avatar,
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Theme,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import { KeyboardArrowRight } from "@material-ui/icons";
import React from "react";
import { Link, Redirect } from "react-router-dom";
import { ISchool } from "src/services";
import Component from "../components/Component";
import { AppContextConsumer, IAppContext } from "../components/withAppContext";
import withAxios, { IAxiosProps } from "../components/withAxios";
import VideoModal from "src/components/videoModal";
import { FILE_URL } from "src/constants";
import SearchSchoolView from "src/components/searchSchool";


const styles = (theme: Theme) => ({
  progressLoader: {
    color: "#fff",
  },
  progressLoaderNew: {
    color: "#494b8f",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "0.75rem",
    height: "100%",
    overflow: "hidden",
    padding: "0px",
    width: "20rem",
    zIndex: 1,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.3)",
    },
  },
  loader: {
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 0,
  },
  schoolSelectorHeader: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    padding: "1rem",
  },
  text: {
    color: "#000",
  },
  showMoreText: {
    color: "#000",
    padding: "15px 10px"

  }
});

type IProps = WithStyles<keyof ReturnType<typeof styles>> &
  IAxiosProps &
  IAppContext;

interface ISelectSchoolPageState {
  schools: ISchool[];
  loading?: boolean;
  url: string,
  showVideo: boolean;
  page: number,
  totalPage: number,
  loadMore: boolean,
  searchBy: string,
  searchValue: string
}

const SchoolSelector = withStyles(styles)(
  withAxios(
    class extends Component<IProps, ISelectSchoolPageState> {
      public readonly state = this.buildState({
        schools: [],
        url: '',
        showVideo: false,
        page: 1,
        totalPage: 1,
        loadMore: false,
        searchBy: "",
        searchValue: ''
      });

      public componentDidMount() {
        this.checkSchoolList();       

      }

      public schollLoadHandler() {
        this.setState({
          page: 1,
          totalPage: 1,
        })
        console.log("this.props?.user?.isAdmin",this.props?.user?.isAdmin)
        if (!this.props?.user?.isAdmin) {
          this.loadUserSchool();
        } else {
          this.loadUserGetSchool(true)
        }
      }
      public async getWelcomeVideo() {
        const res: any = await this.buildGet(this, "video/getOneVideo/1")()

        console.log("res----------->", res)
        this.setState({ url: res?.data?.file || "" }, () => {
          if (res.status) {
            this.setState({ showVideo: true })
          }
        })
      }

      public async videoCountAPI() {
         
        const res: any = await this.buildPut(
          this,
          `user/videoCount`
        )({
          "userId": this.props?.user?.id,
          "videoCount": this.props?.user?.videoCount
        });
console.log(this?.props?.user?.id,"this.props")
const response = await this.buildPost<any, any>(
  this,
  "/coaches/getCoachStatus"
)({
  userId: this.props?.user?.id,
});
console.log("testing 123")
// No need for response.json()
const apiData = response;  

console.log("API Response ===>", apiData);

const hasHead = apiData?.data?.some((item: any) => item.type === "head");

console.log("Has head type?", hasHead);

//         const response = await this.buildPost<any, any>(
//     this,
//     "/coaches/getCoachStatus"
//        )({
//   "userId": "731"
// });
// const apiData = await response.json();
// console.log("API Response ===>", apiData);

// const hasHead = apiData?.data?.some((item: any) => item.type === "head");

// console.log("Has head type?", hasHead); // true or false
// console.log(ResGetCoachStatus,"ResGetCoachStatus")
// console.log("VIDEO-COUNT=========>", res?.data?.videoCount < 3)

        if (res?.data?.videoCount > 3 ) {
          this.setState({ showVideo: false })
          this.schollLoadHandler()
        } else {
          // console.log("this is video wala section ")
          if(!hasHead){
            this.getWelcomeVideo()
           }else{
             this.schollLoadHandler()
           }

        }

      }
      public render() {
        const { classes, user } = this.props;
        const { loading, schools } = this.state;
        // If we only have one option select for them
        return (
          <>
            {loading && (
              <Box className={classes.loader} position="absolute">
                <CircularProgress
                  size="3rem"
                  className={classes.progressLoader}
                />
              </Box>
            )}
            {!loading && (
              <>
                {!user.isAdmin && schools.length === 1 && (
                  <Redirect to={`/${schools[0].slug}`} />
                )}
                {this.renderSchools()}
              </>
            )}

          </>
        );
      }

      private renderSchools() {
        const { classes, user } = this.props;
        const { loading, schools } = this.state;

        const schoolListItemHeight = 63;
        const schoolViewMax = 6;
        const bufferHeight = 20;

        return (
          <>
            {loading && (
              <Box className={classes.loader} position="absolute">
                <CircularProgress
                  size="3rem"
                  className={classes.progressLoader}
                />
              </Box>
            )}

            {!loading && (
              <Box className={classes.card} position="relative">
                <Typography
                  variant="h6"
                  className={classes.schoolSelectorHeader}
                >
                  Select A School
                </Typography>
                <Box
                  style={{
                    maxHeight: `calc(${schoolListItemHeight * schoolViewMax
                      }px + ${bufferHeight}px)`,
                    overflow: "scroll",
                  }}
                >
                  {!user?.isAdmin ? null : <SearchSchoolView onSubmit={(searchBy: any, searchValue: any) => {
                    this.setState({
                      page: 1,
                      totalPage: 1,
                      searchBy,
                      searchValue,
                      schools: [],
                    }, () => {
                      this.loadUserGetSchool()
                    })

                  }} />}
                  <List style={{ padding: "0px" }}>
                    {schools.length > 0 && schools.map(({ slug, id, logo1, name, tagline }) => (
                      <ListItem
                        className={classes.listItem}
                        component={Link}
                        {...({ to: `/${slug}` } as any)}
                        dense={true}
                        divider={true}
                        key={id}
                      >
                        <ListItemAvatar>
                          <Avatar src={logo1} />
                        </ListItemAvatar>
                        <ListItemText
                          disableTypography={true}
                          primary={
                            <Typography
                            style={{wordBreak:"break-all"}}
                              className={classes.text}
                              variant="body2"
                            >
                              {name}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              className={classes.text}
                              variant="caption"
                            >
                              {tagline}
                            </Typography>
                          }
                        />
                        <ListItemSecondaryAction>
                          <KeyboardArrowRight color="primary" />
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>

                </Box>
                {!user?.isAdmin ? null : this.state.page < this.state.totalPage && <Typography
                  style={{ textAlign: 'center' }}
                  className={classes.showMoreText}
                  variant="body2"
                  onClick={() => {
                    if (this.state.page < this.state.totalPage) {
                      this.setState({ page: this.state.page + 1 }, () => {
                        this.loadUserGetSchool()
                      })
                    }
                  }}
                >
                  <span style={{cursor:"pointer"}}>
                  Show More
                  </span>
                </Typography>}
                {/* <button onClick={() => {
                  if (this.state.page < this.state.totalPage) {
                    this.setState({ page: this.state.page + 1 }, () => {
                      this.loadUserGetSchool()
                    })
                  }
                }}>Show More</button> */}

                {this.state.loadMore && <Box className={classes.loader} position="absolute">
                  <CircularProgress
                    size="3rem"
                    className={classes.progressLoaderNew}
                  />
                </Box>}
              </Box>
            )}
            {(this.state.url !== "" && !user.isAdmin) && <VideoModal videoURL={FILE_URL + "/" + this.state.url} open={this.state.showVideo} handleClose={() => {
              this.setState({ showVideo: !this.state.showVideo })
              this.schollLoadHandler()
            }} />}
          </>
        );
      }

      private readonly logoutAndRedirect = async () => {
        try {
          sessionStorage.removeItem("newUserDetails");
          if (this.props.user?.id !== undefined) {
            await this.buildPost<{}, void>(this, "logout")({});
          }
        } catch (error) {
          console.error("Logout failed", error);
        } finally {
          window.location.href = "/";
        }
      };

      private readonly acceptInvitation = async () => {
        const token = localStorage.getItem("invitationToken");
        const email = localStorage.getItem("invitationEmail");
        if (token && email) {
          try {
            await this.buildPost(this, "/accept-invitation")({ token, email });
            console.log("Invitation accepted successfully on school list");
            // Remove from localStorage after successful call
            localStorage.removeItem("invitationToken");
            localStorage.removeItem("invitationEmail");
          } catch (err: any) {
            console.error("Error accepting invitation:", err);
          }
        }
      };

      private readonly redirectToPendingInviteIfExists = async () => {
        const email = this.props.user?.email;
        if (!email) {
          return false;
        }

        try {
          const response: any = await this.buildGet<any>(
            this,
            `pending-invitation/${encodeURIComponent(email.trim().toLowerCase())}`
          )();
          if (response?.status && response?.data?.email) {
            window.location.href = `/pending-invite?email=${encodeURIComponent(response.data.email)}`;
            return true;
          }
        } catch (error) {
          console.error("Pending invitation lookup failed", error);
        }
        return false;
      };
      private readonly loadUserSchool = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: false,
          },
          async () => {
            const res: any = await this.buildGet<ISchool[]>(this, "school")()
            console.log("res----------->", res)
            this.setState({
                schools: res,
              }, async () => {
                 // // this.getWelcomeVideo()
              // this.videoCountAPI()
                if (res.length === 0 && this.props.user?.isAdmin === false) {
                  const redirected = await this.redirectToPendingInviteIfExists();
                  if (!redirected) {
                    alert("Your school has been deactivated or you have not accepted the invitation sent in the email. Please contact the administrator.");
                    this.logoutAndRedirect();
                  }
                }

                // Accept invitation to mark user's status as accepted
                await this.acceptInvitation();
              });
          },
          () => {
            // Do nothing
          }
        );   
         private readonly checkSchoolList = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: false,
          },
          async () => {
            const res: any = await this.buildGet<ISchool[]>(this, "school")()
            console.log("res----------->", res)
            if (res.length === 0 && this.props.user?.isAdmin === false) {
                  const redirected = await this.redirectToPendingInviteIfExists();
                  if (!redirected) {
                    alert("Your school has been deactivated or you have not accepted the invitation sent in the email. Please contact the administrator.");
                    this.logoutAndRedirect();
                  }
                }else{
                  if(!this.props?.user?.isAdmin){
          this.videoCountAPI()
        }else{
          this.schollLoadHandler()
        }
                }

          },
          () => {
            // Do nothing
          }
        ); 
      private calculateTotalPages(totalData: any, itemsPerPage: any) {
        return Math.ceil(totalData / itemsPerPage);
      }
      private readonly loadUserGetSchool = (initial = false) =>
  void this.runCancellableStatefulAsync(
    this,
    {
      loading: initial ? true : false,
      loadMore: !initial ? true : false,
    },
    {
      loadMore: false,
      loading: false,
    },
    async () => {
      let url = '';
      const isAdminSchoolsPage = window.location.pathname === '/admin/schools';

      if (this.state.searchBy !== "" && this.state.searchValue !== "") {
        url = `school/getAll?pageNumber=${this.state.page}&pageSize=10&${this.state.searchBy}=${this.state.searchValue}`;
        if (!isAdminSchoolsPage) {
          url += `&status=true`;
        }
      } else {
        url = `school/getAll?pageNumber=${this.state.page}&pageSize=10`;
        if (!isAdminSchoolsPage) {
          url += `&status=true`;
        }
      }
      const res: any = await this.buildGet<ISchool[]>(this, url)();
      console.log("res===========>School", res.data)
      if (res?.data?.totalCount > 0) {
        const totalPages = this.calculateTotalPages(res?.data?.totalCount, 10);
        this.setState({
          schools: [...this.state.schools, ...res?.data?.data],
          totalPage: totalPages,
          loadMore: false,
        }, async () => {
          console.log("schollLoadHandler")

          // Accept invitation to mark user's status as accepted
          await this.acceptInvitation();
        });
      } else {
        this.setState({
          schools: [],
          totalPage: 1,
          page: 1,
          loadMore: false,
        })
      }
    },
    () => {
      // Do nothing
    }
  );
    }
  )
);

export default () => (
  <AppContextConsumer>
    {(context) => <SchoolSelector {...context} />}
  </AppContextConsumer>
);





// WEBPACK FOOTER //
// ./src/pages/SelectSchoolPage.tsx